import React from "react";
import "../styles/pages/sucess.scss";

export const PageSucessPayment = () => {
  return (
    <div className="page_sucess">
      <div>
        <p>We sucessfully receive your payment</p>
        <br />
        <a href="/">Back to Home page</a>
      </div>
    </div>
  );
};
